import { extractIds } from './extractIds';

export const extractValidIds = (ids: any[]) => {
  if (!Array.isArray(ids) || !ids.every((mfcId) => typeof mfcId === 'string')) {
    return ids; // Assuming the intention is to process even invalid data
  }
  return extractIds(ids); // Use your specific `extractIds` function
};
